import React from 'react';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Marcus P.',
      role: 'Fleet Manager',
      text: '"Switching to Fidelio cut dispatch time by over 50%."',
      rating: 5
    },
    {
      name: 'Sarah L.',
      role: 'Logistics Coordinator',
      text: '"The AI matching was tracking spreadsheets and constant calls."',
      rating: 5
    },
    {
      name: 'David M.',
      role: 'Owner-Operator',
      text: '"The onboarding was seamless and we were up and running in under a day."',
      rating: 5
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-center mb-16 text-gray-900">
          Real Results from Real Fleet Managers
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              
              <p className="text-white text-lg mb-6 leading-relaxed">
                {testimonial.text}
              </p>
              
              <div>
                <p className="text-white font-bold">{testimonial.name}</p>
                <p className="text-gray-400 text-sm">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
